import { useEffect, useState } from "react";
import { Card } from "@/components/ui/card";
import { Calendar } from "lucide-react";
import { getLunarDate } from "@/data/fortuneData";

export const LunarDate = () => {
  const [currentDate, setCurrentDate] = useState("");
  const [lunarDate, setLunarDate] = useState("");

  useEffect(() => {
    const updateDate = () => {
      const now = new Date();
      const options: Intl.DateTimeFormatOptions = {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        weekday: 'long'
      };
      
      setCurrentDate(now.toLocaleDateString('zh-TW', options));
      setLunarDate(getLunarDate());
    };

    updateDate();
    const interval = setInterval(updateDate, 60000); // 每分鐘更新一次

    return () => clearInterval(interval);
  }, []);

  return (
    <Card className="bg-gradient-to-r from-red-600 to-red-700 text-white p-4 shadow-lg">
      <div className="flex items-center justify-center space-x-4">
        <Calendar className="w-6 h-6" />
        <div className="text-center">
          <div className="text-lg font-semibold">{currentDate}</div>
          <div className="text-red-100 text-sm">{lunarDate}</div>
        </div>
      </div>
    </Card>
  );
};